import React from 'react'
import styled from 'styled-components'
import Card from './Card'
import { InnerLayout } from './Layout'
import check from '../../Assets/img/check.svg';
import checkDisabled from '../../Assets/img/check-disabled.svg';
import DetailCard from './DetailCard';
import { Container } from "react-bootstrap";
import Particle from "../Particle";


import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";



const RoboticsCard = () => {

  const navigate = useNavigate(); // Initialize navigate

  const handleClick = () => {
    navigate("/courses"); // This will navigate to the "/another-page" route
  };
    
    return (
        <Container >
      <ParticleWrapper>
                <Particle />
            </ParticleWrapper>
      <PaymentStyled id='pricing'>
         <InnerLayout>
            <div data-aos='fade-down-right'>
               <h3 className="small-heading">                
                Electronics and Robotics Training 
               </h3>
               <p className="c-para">Hands-On Learning for Tomorrow’s Innovators </p>
               <p>The Electronics and Robotics Training at Choicest Fruit® empowers youth ages 14–24
                 to explore the exciting world of electronics, engineering, and robotics. Perfect for
                  beginners or those looking to enhance their portfolio, this program provides a strong 
                  foundation in both theory and hands-on practice, preparing participants for advanced 
                  projects and careers in STEM fields.</p>
            </div>
            <Button onClick={handleClick}>View Trainings</Button>
            <div className='card-con'>
               <Card
                  account={'What You’ll Learn'}                 
                  text={'Cultivating creativity, critical thinking, and the skills to innovate responsibly in a technology-driven world.'}
                  button={'Register Here'}          
                link="https://docs.google.com/forms/d/e/1FAIpQLSc49Ind-eStUwPQ6hM08YfwIozNRR6ffXkGf7iqCNIbY-jJmA/viewform" 
                //   active={active}
                //   inactive={inactive}
                  check={check}
                  checkDis={checkDisabled}
                  text1={'Fundamentals of Electronics: Understand voltage, current, resistance, Ohm’s law, circuits, and essential electronic components.'}
                  text2={'Circuit Design: Learn to design functional electronic circuits using the principles of the engineering design process.'}
                  text3={'Hands-On Experience: Work individually and in groups to design, assemble, test, and troubleshoot electronic systems.'}
                  text4={'Complex Projects: Progress to more advanced electrical and robotic projects that integrate mechanics, electronics, and sensory feedback systems. '}
                  text5={'Robotics Understanding: Learn how robots operate and how to apply multidisciplinary approaches to design and build them effectively.'}
                  text6={'Final Project: Complete a capstone project that showcases your skills in electronics and robotics, demonstrating your ability to innovate and solve problems.'}
                
               />

               <Card
                  account={'Payment'}
                  amount={'$350'}
                  text={'A seamless and user-friendly payment integration.'}
                button={'Pay Here'}
                link="https://checkout.square.site/merchant/MLAY6G9T625V1/checkout/OQEMR44MUAV2YECNI7PXQSLK"                
                //   active={active}
                //   inactive={inactive}
                  check={check}
                  checkDis={checkDisabled}
                  text1={'Training Length: 2 months.'}
                  text2={'Experience: No experience needed.'}
                  text3={'Certification: Certificate awarded upon completion.'}
                  text4={'Training Setting: In-Person.'}
                  text5={'Hardware Requirements: Arduino or ELEGOO UNO project starter kit.'}
                  text6={'Training Requirements: Access to internet.'}
                //   text7={'Exchange 24 currencies'}
                //   text8={'Multi-user access'}
                 />

           </div>
         </InnerLayout>
            </PaymentStyled>
            <Container>
                <DetailCard/>
                </Container>
            </Container>
      
   )
}

const ParticleWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;  // Place it behind all other content
`;

const PaymentStyled = styled.section`
 .card-con {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 2rem; /* Reduce the gap between the cards */
    padding-top: 4rem; /* Reduce top padding */
    
    /* Optional: Use max-width to control the card's maximum size */
    max-width: 1200px;
    margin: 0 auto;
        
    @media screen and (max-width: 689px) {
      grid-template-columns: 1fr; /* Stack cards on mobile */
    }
  }

  p {
    text-align: center;
  }
`



export default RoboticsCard
